import { css } from 'styled-components';
import { MOBILE_WIDTH } from './const';

export const PRIMARY_TEXT_COLOUR = '#3D3F42';
export const SECONDARY_TEXT_COLOUR = '#6F7783';

export const VIDAPP_GRADIENT = 'linear-gradient(90deg, #F4845F 0%, #F16A75 100%)';

export const PRIMARY_COLOUR = '#F4845F';
export const DISABLED_COLOUR = '#C1C7D1';

export const InputStyles = css`
  width: 100%;
  border-color: ${SECONDARY_TEXT_COLOUR} !important;
`;
export const InputFocusStyles = css`
  :focus-within,
  :hover {
    border-color: ${SECONDARY_TEXT_COLOUR} !important;
    box-shadow: none !important;
  }
`;
export const InputFontStyles = css`
  color: ${PRIMARY_TEXT_COLOUR};

  ::placeholder {
    color: ${SECONDARY_TEXT_COLOUR};
  }

  font-size: 16px;
  line-height: 19px;
  @media (max-width: ${MOBILE_WIDTH}) {
    font-size: 13px !important;
    line-height: 15px !important;
  }
`;

export const InputPadding = css`
  padding-left: 22px;
  padding-right: 22px;
  @media (max-width: ${MOBILE_WIDTH}) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;
export const InputSize = css`
  border-radius: 8px;

  height: 56px;
  @media (max-width: ${MOBILE_WIDTH}) {
    height: 45px !important;
  }
`;

export const FormContentStyles = css`
  padding-top: 40px;
  height: 470px;
  min-height: 470px;
  @media (max-width: ${MOBILE_WIDTH}) {
    min-height: 400px;
    height: 400px;
  }
`;
